(function() {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('Diagnosis', Diagnosis);

    Diagnosis.$inject = ['$resource'];

    function Diagnosis ($resource) {
        var resourceUrl =  'api/diagnoses/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'byPatientOrderTest': {url: 'api/diagnoses/by-patient-order-test/:id', method: 'GET', isArray: true}
        });
    }
})();
